import action from './action';

const Component = () => import('./Profile');

export { Component, action };
